import React, { useRef } from "react";
import { Box, Typography, IconButton } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import { useNavigate } from "react-router-dom";

export default function BlogsV2({ isSmallScreen }) {
    const scrollRef = useRef();
    const navigate = useNavigate();

    const scroll = (dir) => {
        scrollRef.current.scrollBy({
            left: dir === "left" ? -420 : 420,
            behavior: "smooth",
        });
    };

    const items = [
        {
            type: "image",
            image:
                "https://cloudcasts.io/img/course-assets/terraform.png",
            title: "Top 20 Terraform Interview Questions & Answers",
            desc: "If you’re preparing for a DevOps role in 2026, you need to brush up on Terraform interview questions. Terraform has been  the main tool that teams use for infrastructure as code around the world.",
            cta: "Learn More",
        },
        {
            type: "gradient",
            gradient:
                "linear-gradient(135deg, #1a001f 0%, #6a0dad 100%)",
            title: "What is Ansible in DevOps — And Why Every Engineer Needs It",
            desc: "If you walk into any serious engineering team today you will probably hear someone talk about Ansible in DevOps.",
            cta: "Explore More",
        },
        {
            type: "dark",
            gradient:
                "linear-gradient(135deg, #000000 0%, #1c1c1c 100%)",
            title: "The Future of DevOps Certification: What IT Pros Need to Know",
            desc: "IT infrastructure is in flux. DevOps certification is no longer a checkbox—it’s the launchpad for careers in a world where AI, multi-cloud architectures, and security-first practices define success.",
            cta: "Learn More",
        },
        {
            type: "purple",
            gradient:
                "linear-gradient(135deg, #4b0c5c 0%, #8a0f6b 100%)",
            title: "Online DevOps Courses: Your Complete Guide to Mastering DevOps",
            desc: "Picture this: It's 2 AM, your deployment has failed for the third time, and your team is scrambling to fix production issues whilst developers and operations are pointing fingers at each other.",
            cta: "Learn More",
        },
        {
            type: "dark",
            gradient:
                "linear-gradient(135deg, #000000 0%, #1c1c1c 100%)",
            title: "Why Kubernetes & Terraform Are Must-Have Skills in Any DevOps Certification",
            desc: "Let’s face it — DevOps isn’t what it used to be. Gone are the days of manual deployments, endless server configurations, and “it works on my machine” excuses.",
            cta: "Learn More",
        },
        {
            type: "purple",
            gradient:
                "linear-gradient(135deg,rgb(126, 99, 215) 0%,rgb(45, 17, 72) 100%)",
            title: "Top 10 Jenkins Plugins You Need for Your CI/CD Pipeline.",
            desc: "If you've spent any time working with Jenkins, you already know it's one of the most powerful open-source automation servers out there.But here's the thing — Jenkins out of the box is just the beginning",
            cta: "Learn More",
        },
        {
            type: "cta",
            gradient: "linear-gradient(135deg,rgb(140, 140, 140) 0%,rgb(140, 140, 140) 100%)",
            title: "Explore All Insights",
            desc: "Dive deeper into DevOps, Cloud, and real-world career guides.",
            cta: "View all blogs →",
        }
    ];

    return (
        <Box sx={{ py: isSmallScreen ? 4 : 8, px: isSmallScreen ? 2 : 10, }}>
            <Typography
                sx={{
                    fontSize: isSmallScreen ? "26px" : "42px",
                    fontWeight: 600,
                    mb: 5,
                    fontFamily: "Poppins",
                }}
            >
               Paperlive Learning Blogs
            </Typography>

            {/* Carousel */}
            <Box sx={{ position: "relative" }}>
                <Box
                    ref={scrollRef}
                    sx={{
                        display: "flex",
                        gap: 2,
                        overflowX: "auto",
                        scrollSnapType: "x mandatory",

                        // ❌ remove weird left shift on mobile
                        pl: isSmallScreen ? "10vw" : "max(120px, 25%)",
                        pr: isSmallScreen ? "10vw" : "6%",

                        "&::-webkit-scrollbar": { display: "none" },
                    }}
                >
                    {items.map((item, i) => (
                        <Box
                            key={i}
                            onClick={() => navigate('/blog')}
                            sx={{
                                minWidth: isSmallScreen ? "80vw" : "380px",
                                borderRadius: "14px",
                                overflow: "hidden",
                                scrollSnapAlign: isSmallScreen ? "center" : "start",
                                background:
                                    item.type === "image"
                                        ? "#f6f3f2"
                                        : item.gradient,
                                color: item.type === "image" ? "#000" : "#fff",
                                transition: "0.35s",
                                cursor: "pointer",
                                "&:hover": {
                                    transform: "translateY(-8px)",
                                },
                            }}
                        >
                            {/* Top Section */}
                            {item.type === "image" ? (
                                <Box
                                    component="img"
                                    src={item.image}
                                    sx={{
                                        width: "100%",
                                        height: 180,
                                        objectFit: "cover",
                                    }}
                                />
                            ) : (
                                <Box sx={{ height: 180 }} />
                            )}

                            {/* Content */}
                            <Box sx={{ p: 3 }}>
                                <Typography
                                    sx={{
                                        fontSize: "18px",
                                        fontWeight: 600,
                                        mb: 1,
                                        fontFamily: "Poppins",
                                    }}
                                >
                                    {item.title}
                                </Typography>

                                <Typography
                                    sx={{
                                        fontSize: "14px",
                                        opacity: 0.8,
                                        mb: 2.5,
                                        fontFamily: "Poppins",
                                    }}
                                >
                                    {item.desc}
                                </Typography>

                                <Box sx={{ display: "inline-block" }}>
                                    <Typography
                                        sx={{
                                            fontSize: "14px",
                                            fontWeight: 500,
                                            fontFamily: "Poppins",
                                        }}
                                    >
                                        {item.cta}
                                    </Typography>
                                    <Box
                                        sx={{
                                            height: "2px",
                                            width: "100%",
                                            background: "#f5a623",
                                            mt: 0.5,
                                        }}
                                    />
                                </Box>
                            </Box>
                        </Box>
                    ))}
                </Box>

                {/* Arrows */}
                {(
                    <Box
                        sx={{
                            display: "flex",
                            justifyContent: "flex-end",
                            mt: 4,
                            gap: 2,
                        }}
                    >
                        <IconButton
                            onClick={() => scroll("left")}
                            sx={{
                                background: "#eee",
                                borderRadius: "8px",
                            }}
                        >
                            <ArrowBackIcon />
                        </IconButton>

                        <IconButton
                            onClick={() => scroll("right")}
                            sx={{
                                background: "#6a0dad",
                                color: "#fff",
                                borderRadius: "8px",
                                "&:hover": { background: "#5a0cb0" },
                            }}
                        >
                            <ArrowForwardIcon />
                        </IconButton>
                    </Box>
                )}
            </Box>
        </Box>
    );
}